import { Component, Input, OnInit } from '@angular/core';
import { Position } from '../../../common';

@Component({
  selector: 'skc-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.less']
})
export class ArticleComponent implements OnInit {
  @Input('skc-animation') animation;
  @Input('skc-image-width') imageWidth = '12em';
  @Input('skc-image-height') imageHeight = '12em';
  @Input('skc-image-src') imageSrc = './assets/icons/picture.svg';
  @Input('skc-image-horizontal') imageHorizontal = Position.LEFT;
  @Input('skc-image-vertical') imageVertical = Position.TOP;
  @Input('skc-border') border = false;
  positionType = Position;
  constructor() {}

  ngOnInit() {}
}
